<app-task-list-widget
    [autoFocusSearch]="false"
    [fillHeightList]="fillHeightList"
    [addInDialog]="true"
    [dialogEditMode]="true"
    [checkboxMode]="false"
    [autoloadItems]="false"
/>
